import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getSkillSubjects = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SKILL_SUBJECT_ALL, {
    params: {
      isApproved: true,
      isActive: true,
    },
  });
};

export const getSkillSubjectAll = (
  StateId,
  GradeId,
  contentAreaId,
  subjectname,
  isApproved,
  isActive,
  SkillSubjectId,
  OrderByColumn,
  SortDir,
  pageSize,
  pageNumber
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SKILL_SUBJECT_ALL, {
    params: {
      StateId: StateId,
      GradeId: GradeId,
      ContentAreaId: contentAreaId,
      name: subjectname,
      isApproved: isApproved,
      isActive: isActive,
      SkillSubjectId: SkillSubjectId,
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};
export const getSkillSubjectExport = (
  StateId,
  GradeId,
  contentAreaId,
  subjectname,
  isApproved,
  isActive,
  SkillSubjectId,
  OrderByColumn,
  SortDir,
  pageSize,
  pageNumber
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SKILL_SUBJECT_EXPORT, {
    params: {
      StateId: StateId,
      GradeId: GradeId,
      ContentAreaId: contentAreaId,
      name: subjectname,
      isApproved: isApproved,
      isActive: isActive,
      SkillSubjectId: SkillSubjectId,
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const postSkillSubject = (postStandardData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SKILL_SUBJECT,
    postStandardData,
    {}
  );
};

export const deleteSkillSubjectAPI = (subjectId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SKILL_SUBJECT, {
    params: {
      id: subjectId,
    },
  });
};

export const getSkillSubjectAPI = (subjectId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SKILL_SUBJECT_ONE + subjectId
  );
};

export const updateSkillSubject = (updateSubject) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SKILL_SUBJECT,
    updateSubject,
    {}
  );
};

export const getSkillStandardAll = (
  SkillStandardId,
  SkillSubjectId,
  GradeId,
  isApproved,
  isActive,
  OrderByColumn,
  SortDir,
  pageSize,
  pageNumber
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SKILL_STANDARD_ALL, {
    params: {
      SkillStandardId: SkillStandardId,
      SkillSubjectId: SkillSubjectId,
      GradeId: GradeId,
      isApproved: isApproved,
      isActive: isActive,
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const postSkillStandard = (postStandardData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SKILL_STANDARD,
    postStandardData,
    {}
  );
};

export const deleteSkillStandardAPI = (StandardId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SKILL_STANDARD, {
    params: { id: StandardId },
  });
};

export const getSkillStandard = (StandardId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SKILL_STANDARD_ONE + StandardId
  );
};

export const updateSkillStandard = (updateSubject) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SKILL_STANDARD,
    updateSubject,
    {}
  );
};

export const getSkillQuestionAll = (
  GradeId,
  SkillStandardId,
  SkillSubjectId,
  isApproved,
  isActive,
  SkillQuestionId,
  OrderByColumn,
  SortDir,
  pageSize,
  pageNumber
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SKILL_QUESTION_ALL, {
    params: {
      GradeId: GradeId,
      SkillStandardId: SkillStandardId,
      SkillSubjectId: SkillSubjectId,
      isApproved: isApproved,
      isActive: isActive,
      SkillQuestionId: SkillQuestionId,
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const postSkillQuestion = (postQuestiondData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SKILL_QUESTION,
    postQuestiondData,
    {}
  );
};

export const updateSkillQuestion = (updateQuestion) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SKILL_QUESTION,
    updateQuestion,
    {}
  );
};

export const deleteSkillQuestionAPI = (QuestionId, userId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SKILL_QUESTION, {
    params: { id: QuestionId, userId: userId },
  });
};

export const getSkillQuestionOne = (id) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SKILL_QUESTION_ONE + id
  );
};
